const convertUtils = {
    toBoolean(value) {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'string') {
            return ['true', '1', 'yes', 'on'].includes(value.toLowerCase());
        }
        return Boolean(value);
    },
};

export default convertUtils;
